
import Header from 'components/ui/header'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getConfig } from 'services/activity';
import Renderif from 'utils/renderif';

export default function GameView({onProceed}) {
   const navigate = useNavigate()
     const location = useLocation()


    const _activity = location.state?.activity
  const { id } = useParams()

 const [storedValue, setStoredValue] = useState(localStorage.getItem('win') || '')
 const [config, setConfig] = useState({
  logo:"",
  bgcolor:"#000000",
  bgheader:"#000000",
  textcolor:"#000000"
 })
  const [loading, setLoading] = useState(false)
//  useEffect(()=>{
//       init()
//        return () => {}
//  },[])


   
  useEffect(() => {
      //  init()
    const handleStorageChange = (event) => {
      // Check if the relevant key has changed
      if (event.key === 'win') {
        if(event.newValue === "1"){
                localStorage.removeItem('win')
                onProceed()
                navigate('/winner', { state: { id: id, reward:"", text:"" } })

        }
        // setStoredValue(event.newValue || '');
      }
    };

    // Add the event listener to the window object
    window.addEventListener('storage', handleStorageChange);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);


  //  const init = async () => {
  //     console.log(_activity);
  //     const _config = await getConfig(_activity.type)
  //     console.log(JSON.parse(_config.data.config))
   
  //     setLoading(false)
  //   }

  return (
    
    <Renderif isTrue={!loading}>
      
    <div className='container-fluid activity vh-100 overflow-auto'>
    
      <Header />
        <div className='container h-100 pt-3'>
            <iframe className='' width="100%" height="100%" src={`/1/index.html`}></iframe>
       </div>
    </div>
    </Renderif>


  )
}
